import "ant-design-vue/es/message/style";
import _message from "ant-design-vue/es/message";
import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-276c1379"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "no-device-body"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "no-tips"
  }, " 电脑设备检测未通过，可能被系统判断为作弊，是否继续？ ", -1);
});
var _hoisted_3 = {
  class: "no-action"
};
var _hoisted_4 = /*#__PURE__*/_createTextVNode("退出，重新检测");
var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 报备异常 ");
import { EnvCheckerService } from '@/services/env/checker.service';
import { useService } from '@kaokei/use-vue-service';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var _this = this;
    var checkerService = useService(EnvCheckerService);
    var startAuth = function () {
      if (checkerService.currentStepIndex !== 0) {
        checkerService.goStep(0);
      } else {
        checkerService.checkStartDevice();
      }
      checkerService.NoDeviceVisible = false;
    };
    var noAuthEntrance = function () {
      return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4 /*yield*/, checkerService.handleIgnoreCheckStep()];
            case 1:
              _a.sent();
              _message.success('报备成功');
              return [2 /*return*/];
          }
        });
      });
    };
    return function (_ctx, _cache) {
      var _component_a_button = _resolveComponent("a-button");
      var _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        visible: _unref(checkerService).NoDeviceVisible,
        "onUpdate:visible": _cache[0] || (_cache[0] = function ($event) {
          return _unref(checkerService).NoDeviceVisible = $event;
        }),
        closable: true,
        "destroy-on-close": true,
        "mask-closable": false,
        keyboard: false,
        width: 523,
        title: null,
        footer: null,
        centered: "",
        class: "no-device-dialog"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_button, {
            class: "btn",
            onClick: startAuth
          }, {
            default: _withCtx(function () {
              return [_hoisted_4];
            }),
            _: 1
          }), _createVNode(_component_a_button, {
            class: "btn",
            type: "primary",
            onClick: noAuthEntrance
          }, {
            default: _withCtx(function () {
              return [_hoisted_5];
            }),
            _: 1
          })])])];
        }),
        _: 1
      }, 8, ["visible"]);
    };
  }
});